<template>
  <el-dialog title="二维码" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="450px">
      <el-select v-model="value" placeholder="请选择" @change="changeCode">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          >
        </el-option>
      </el-select>
       <button v-if="value !='h5'" type="primary" @click="poster_version()" class="dialog_btn">海报板</button>
        <button v-if="value !='h5'" type="primary" @click="copy_version()" class="dialog_btn">印刷板</button>
        <img v-img-url="qrcode_url" class="qrcodestyle2" alt="海报版" v-if="poster_status"/>
        <img v-img-url="copy_code_url" class="qrcodestyle2" alt="印刷版" v-if="copy_status"/>
         <button type="primary" @click="remakeCode()" class="dialog_btn" v-if="copy_status">重新生成</button>
         <button type="primary" @click="remakeQrcode()" class="dialog_btn" v-if="poster_status">重新生成</button>
  </el-dialog>
</template>

<script>
import PlusApi from '@/api/plus.js';
export default {
  components: {
    /*编辑组件*/
    PlusApi
  },
  data() {
    return {
      options: [ {
        value: 'h5',
        label: 'H5'
      },{
        value: 'wx',
        label: '小程序'
      },
      //  {
      //   value: 'mp',
      //   label: '公众号'
      // }
    ],
      value: 'h5',
      
      /*是否显示*/
      dialogVisible: true,
      poster_status:true,
      copy_status:false,
      copy_code_url: '',
      qrcode_url:''
    };
  },
  props: ['is_show', 'qrcode','code_url','user_id'],
  watch:{

  },  
  created() {
    this.copy_code_url = this.code_url;
    this.qrcode_url = this.qrcode;
  },
  methods: {
    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit('closeDialog', {
        type: this.type,
        openDialog: false,
        params: this.params
      });
    },

    poster_version(){
      this.poster_status = true;
      this.copy_status = false
    },
    copy_version(){
      this.poster_status = false;
      this.copy_status = true
    },
    // 重新生成
    remakeQrcode(){
       let self = this;
      let user_id = this.user_id;
      let form = {
        'user_id':user_id,
        'source':this.value,
      };

      self.loading = true;
      PlusApi.remakeQrcode(form, true)
      .then(data => {
        self.loading = false;
        if (data.code == 1) {
          self.copy_status  = false;
          self.poster_status  = true;
          self.qrcode_url = data.data.qrcode
        } else {
          self.$message({
            message: '二维码生成失败',
            type: 'error'
          });
        }
      })
      .catch(error => {
        self.loading = false;
      });
    },
    // 选择改变
    changeCode(){
      let self = this;
      let user_id = this.user_id;
      let form = {
        'user_id':user_id,
        'source':this.value,
      };
      self.user_id = user_id

      self.loading = true;
      PlusApi.findPosterCode(form, true)
      .then(data => {
        self.loading = false;
        if (data.code == 1) {
          self.isshow  = true;
          self.qrcode_url = data.data.qrcode;
          self.copy_code_url = data.data.code_url
        } else {
          self.$message({
            message: '二维码生成失败',
            type: 'error'
          });
          self.qrcode_url = "";
          self.copy_code_url = "";
        }
      })
      .catch(error => {
        self.loading = false;
        self.$message({
            message: '二维码生成失败',
            type: 'error'
          });
          self.qrcode_url = "";
          self.copy_code_url = "";
      });
    },
    // 重新生成
    remakeCode(){
      let self = this;
      let user_id = this.user_id;
      let form = {
        'user_id':user_id,
        'source':this.value,
      };

      self.loading = true;
      PlusApi.remakeCode(form, true)
      .then(data => {
        self.loading = false;
        if (data.code == 1) {
          self.copy_status  = true;
          self.poster_status  = false;
          self.copy_code_url = data.data.qrcode
        } else {
          self.$message({
            message: '二维码生成失败',
            type: 'error'
          });
        }
      })
      .catch(error => {
        self.loading = false;
      });
    }
  },

};
</script>

<style>
.qrcodestyle2{
    /*width: 200px;*/
    /*height: 200px;*/
    width: 60%;
    text-align: center;
    margin: auto;
}
.el-dialog__body{
  text-align: center;
}
.dialog_btn{
  padding: 7px;
  margin: 10px;
  border-radius: 6.8px;
  border: 1px;
  color: white;
  background: #3391ec;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/agent/user/code.vue